export default __webpack_public_path__ + "Src/Client/ProductPage/ProductPageTaxonomy/productPageTaxonomy.html";